import React from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap'
import { useEffect } from "react";

function Other() {

    const Porfolio = [
        { P: 'Old web pages', L: '/old-web-pages', C: 'image web' },
        { P: 'Desktop applications', L: '/desktop', C: 'image code' },
        { P: 'Data bases', L: '/data-base', C: 'image bd' },
        { P: 'Video games', L: '/video-games', C: 'image games' }
    ];

    useEffect(() => {
        gsap.from('.card',
            {
                duration: 0.1,
                scale: 0,
                stagger: 0.1,
                opacity: 0
            })
    }, []);

    return (
        <React.Fragment>
            <section className="Proyects">

                <h2 className="">Other projects</h2>
                

                <div className='listPorfolio'>
                    {Porfolio.map(pro => (
                        <Link key={pro.P} to={pro.L} >

                            <div className='card'>
                                <div className='card-image'> <div className={pro.C}></div> </div>
                                <p className='card-title'> {pro.P} </p>
                            </div>
                        </Link>


                    ))}
                </div>
                
                <div className='after'>
                    <Link to="/porfolio" className="Link">  <div className='iconAfter'>  <p className='flechaProyect'>←</p></div>  </Link>
                </div>

            </section>
        </React.Fragment>
    );
}
export default Other;